// SliderContext.js
import { createContext, useContext, useState, useEffect } from 'react';

const SliderContext = createContext();

export const useSlider = () => useContext(SliderContext);

export const SliderProvider = ({ children }) => {
  const [sliderData, setSliderData] = useState([]);
  const [sliderLoading, setSliderLoading] = useState(true);

  useEffect(() => {
    const fetchSliderData = async () => {
      try {
        const response = await fetch('https://snsapiv2.baganit.com/api/app/slider/update', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ platform: "Android", version: "1.0" }),
        });
        const result = await response.json();
        if (result.status === 1 && result.data) {
          setSliderData(result.data);
        }
      } catch (e) {
        console.error('Slider fetch error:', e);
      } finally {
        setSliderLoading(false);
      }
    };

    fetchSliderData();
  }, []);

  return (
    <SliderContext.Provider value={{ sliderData, sliderLoading }}>
      {children}
    </SliderContext.Provider>
  );
};
